module.exports = __webpack_public_path__ + "img/timer-sync-outline.f5ece66d.svg";